import Idioma from "./Idioma";

export default Idioma;
